import { render } from "./NewCustomerModal.vue?vue&type=template&id=1a9959fc&scoped=true&ts=true"
import script from "./NewCustomerModal.vue?vue&type=script&lang=ts"
export * from "./NewCustomerModal.vue?vue&type=script&lang=ts"

import "./NewCustomerModal.vue?vue&type=style&index=0&id=1a9959fc&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9959fc"]])

export default __exports__